'use strict';

function addTopPrioritiesLabelText ($marketingChecklist) {
  $marketingChecklist = $marketingChecklist || $('.marketing-checklist');

  $marketingChecklist
    .find('.marketing-checklist-item-title .label')
    .text(
      $marketingChecklist.find('#top-priorities-label').attr('data-content')
  );

  $marketingChecklist
    .find('.marketing-checklist-list .task-container')
    .first()
    .find('.label')
    .removeClass('hidden');
}

module.exports = addTopPrioritiesLabelText;
